var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MallDepartment",staticStyle:{"text-align":"center"}},[_vm._v(" 商城部-暂无数据 ")])}
var staticRenderFns = []

export { render, staticRenderFns }